import { useEffect } from 'react';

type UseAutoLoadMoreOptions = {
  isTriggerVisible: boolean;
  hasMore: boolean;
  isLoading: boolean;
  hasError: boolean;
  loadMore: () => unknown;
};

/**
 * Loads older messages while their trigger is visible. After a failure the
 * trigger stays visible, so loading resumes only through an explicit retry;
 * otherwise the same page would be requested in an endless loop.
 */
export const useAutoLoadMore = ({
  isTriggerVisible,
  hasMore,
  isLoading,
  hasError,
  loadMore,
}: UseAutoLoadMoreOptions) => {
  useEffect(() => {
    if (isTriggerVisible && hasMore && !isLoading && !hasError) {
      void loadMore();
    }
  }, [isTriggerVisible, hasMore, isLoading, hasError, loadMore]);
};
